module.exports = __webpack_public_path__ + "static/dignity-health-1-834d9eddc5a56d948334851d04ad8006.png";